module.exports = __webpack_public_path__ + "img/spinner-green-48.6fc4c57e.gif";